import Home from './Register'
import {connect} from "react-redux";
import {updateCarPlates, updateOrder, getStoreDeliveryOptions} from "./Register.actions";
import {managePreloader,getOrder} from "../GlobalReduxState/action";

const mapStateToProps = ({globalReducer, registerReducer}: any) => {
return {
    feed: globalReducer.order,
    loading: registerReducer.loading,
    error: registerReducer.error,
    cssStyles: globalReducer.styles,
    deliveryOptions: registerReducer.deliveryOptions
}
};

const mapDispatchToProps = (dispatch:any) => ({
        getOrder: (orderNumber: any) => dispatch(getOrder(orderNumber)),
        callUpdateOrder: (orderCode: any, text: any, deliveryOption: any) => dispatch(updateOrder(orderCode, text, deliveryOption)),
        showPreloader: (show: boolean) => dispatch(managePreloader(show)),
        callUpdateCarPlates: (linkCode: any, carPlates: any, deliveryOption: any) => dispatch(updateCarPlates(linkCode, carPlates, deliveryOption)),
        getStoreDeliveryOptions: (linkCode: any, storeId:number, preview:boolean) => dispatch(getStoreDeliveryOptions(linkCode, storeId, preview))
    });

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Home);
